var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showSummary)?_c('div',{staticClass:"checkout-input-summary"},[_c('ContactInputSummary'),_c('OrderTypeSummary'),_c('ShippingInputSummary'),_c('PaymentInputSummary'),_c('BillingInputSummary')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }